import { schema as attivo } from './attivo';
import { schema as genericXDR } from './generic-xdr';
import { schema as okta } from './okta';
import { schema as sentinelOne } from './sentinel-one';
import { schema as vectra } from './vectra';
import { DATASOURCE, Schema } from './types';

const LIST_OF_SCHEMAS = [attivo, genericXDR, okta, sentinelOne, vectra];

// TODO: Explore reading all directories automatically and load the schemas, which could have an impact on bundling
const entries = LIST_OF_SCHEMAS.map<[DATASOURCE, Schema]>((schema) => [schema.dataSource, schema]);

// Object.fromEntries will always type { [k: string]: T }, so we force the correct typing
// Even https://github.com/sindresorhus/ts-extras/blob/main/source/object-from-entries.ts didn't work well
export const schemas = Object.fromEntries(entries) as { [k in DATASOURCE]: Schema };

// find a schema based on a source value from an event
// DPVZ-2342 if no matching schema is found then return genericXDR schema
// this is to allow custom data sources to send XDR data
// the logic expects the custom data source to define dataSource.name and dataSource.vendor fields
// if they don't define them then they won't get the genericXDR schema either
export const findSchema = (id: string) => {
  // we need to check id to ensure we aren't returning genericXDR for id = ''
  if (id) {
    return LIST_OF_SCHEMAS.find(({ dataSourceId }) => dataSourceId.toLowerCase() === id.toLowerCase()) ?? genericXDR;
  }
};
